import React from "react";
import { useNavigate } from "react-router-dom";
import Reveal from "./Reveal";
import MarbleImage from "./MarbleImage";

/**
 * Reusable tile for live marble type data (Phase B) - used on both the
 * Collection page and the Home page "Collection Preview" section.
 */
const TypeTile = ({ marbleType, revealDelay = 0 }) => {
  const navigate = useNavigate();
  const { slug, type_name, short_description, image_url } = marbleType;

  const onOpen = () => navigate(`/collection/${slug}`);

  return (
    <Reveal delay={revealDelay}>
      <div
        role="link"
        tabIndex={0}
        onClick={onOpen}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onOpen();
          }
        }}
        data-testid={`collection-tile-${slug}`}
        aria-label={`Open ${type_name} marble`}
        className="group relative cursor-pointer overflow-hidden bg-brand-surface ring-1 ring-white/5 transition-all duration-500 hover:ring-brand-gold/45 focus-visible:ring-brand-gold/60 focus-visible:outline-none"
      >
        <div className="relative aspect-[4/5] overflow-hidden">
          <MarbleImage
            src={image_url}
            alt={type_name}
            size="thumb"
            wrapperClassName="absolute inset-0"
            className="transition-transform duration-[1400ms] ease-out group-hover:scale-[1.03]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-charcoal via-brand-charcoal/30 to-transparent" />
        </div>

        <div className="absolute inset-x-0 bottom-0 px-5 md:px-6 pb-5 md:pb-6 pt-10">
          {short_description && (
            <p
              data-testid={`tile-origin-${slug}`}
              className="font-sans text-[10px] uppercase tracking-[0.32em] text-brand-gold/85"
            >
              {short_description}
            </p>
          )}
          <h3
            data-testid={`tile-name-${slug}`}
            className="mt-2 font-serif text-2xl md:text-[30px] font-light text-brand-cream leading-none"
          >
            {type_name}
          </h3>
        </div>
      </div>
    </Reveal>
  );
};

export default TypeTile;
